import $ from 'jquery'
import { Controller } from 'stimulus'
import { updateCartOnEmailChangeDelayed } from '~/site/pages/cart/common'
import { validateEmail } from '~/common/behaviors/email_validation/validation'
import '~/common/behaviors/email_validation/autocorrect'

export default class extends Controller {
  static targets = ['emailField']

  connect() {
    const closestFormId = this.element.closest('form')?.id

    if (closestFormId) {
      const formSelector = `#${closestFormId}`
      const purchaseAutocorrectorSelector = formSelector + ' input[type=email]'

      $(document).initializeEmailAutoCorrector({
        inputSelector: purchaseAutocorrectorSelector,
        correctionTextsDataContainerSelector: formSelector,
        autoCorrectOnSubmit: true,
      })
    }
  }

  emailChanged() {
    validateEmail(this.emailFieldTarget)
    if (this.emailIsValid(this.emailFieldTarget.value)) {
      // Give some time for handlers like inherits-from to run
      updateCartOnEmailChangeDelayed(30)
    }
  }

  // Similar to APP::EMAILS_REGEX
  emailIsValid(inputValue) {
    return /[^@\s]+@[^@\s]/.test(inputValue)
  }
}
